// Module
var code = "<div layout=column layout-align=\"center center\" class=statusWidget><div ng-style=\"{color: '{{vm.color}}'}\" class=\"fa-stack fa-2x\"><i class=\"fa fa-circle fa-stack-2x\"></i><strong class=\"fa-stack-1x fa-inverse\">{{vm.value}}</strong></div><div>{{vm.label}}</div></div>";
// Exports
module.exports = code;